//FUNCIONS
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../../store/createStore';
import {
  findStoreAll,
  storeSelectedRequest,
} from '../../../../../store/modules/parameter/actions';

//HOOKS
import { useCheckoutInfo } from '../../../../../hooks/useCheckoutInfo';

//TYPES
import { Store } from '../../../../../store/modules/parameter/types';
//COMPONENTS

//STYLES
import {
  Container,
  ContainerAddress,
  ContainerAddressList,
  ContainerAddressRow,
  AddressName,
  AddressAddress,
} from '../styles';
import Loading from '../../../../../components/Loading';

const AddressStoreModal: React.FC = () => {
  const { stores, loading } = useSelector(
    (state: StoreState) => state.parameter,
  );
  const dispatch = useDispatch();
  const { onSetSelShipping, onSetaddressSelect } = useCheckoutInfo();

  useEffect(() => {
    dispatch(findStoreAll());
  }, [dispatch]);

  const handleadSelectStore = useCallback(
    async (store: Store) => {
      dispatch(storeSelectedRequest(store));
      onSetaddressSelect({ id: store.store_id, type: 'addressStore' });
      onSetSelShipping(true);
    },
    [dispatch, onSetSelShipping, onSetaddressSelect],
  );

  if (loading) {
    return <Loading size={160} bShowText />;
  }

  return (
    <Container>
      <ContainerAddress>
        <ContainerAddressList>
          {stores &&
            stores.map(store => (
              <ContainerAddressRow
                key={store.store_id}
                onClick={() => handleadSelectStore(store)}
              >
                <AddressName>
                  <span>{store.name}</span>
                  {/* <span>5.1 km</span> */}
                </AddressName>
                <AddressAddress>
                  {store.address}, {store.number} - {store.neighborhood} -{' '}
                  {store.city} - {store.state} - CEP: {store.zip_code}
                </AddressAddress>
              </ContainerAddressRow>
            ))}
        </ContainerAddressList>
      </ContainerAddress>
    </Container>
  );
};

export default AddressStoreModal;
